'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultErrorMessage = undefined;
var _getErrorMessage = require('./get-error-message');
var _getErrorMessage2 = _interopRequireDefault(_getErrorMessage);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var defaultErrorMessage = exports.defaultErrorMessage = function defaultErrorMessage() {
  var defaultErrorString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'This field is invalid';
  return function (_ref) {
    var value = _ref.value,
      values = _ref.values,
      responseCode = _ref.responseCode;
    switch (responseCode) {
      case 200:
        return defaultErrorString;
      case 401:
        return 'Error ' + responseCode + ': Unauthorised';
      case 500:
        return 'Error ' + responseCode + ': Internal server error';
      default:
        return 'An unknown error occured';
    }
  };
};
exports.default = function (request) {
  var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultErrorMessage();
  return function (value, values) {
    return function () {
      var errorMessageGenerator = typeof errorMessage === 'string' ? defaultErrorMessage(errorMessage) : errorMessage;
      return new Promise(function (resolve, reject) {
        return request(value, values).then(function (response) {
          resolve(response.data ? '' : (0, _getErrorMessage2.default)(errorMessageGenerator, {
            value: value,
            values: values,
            responseCode: response.status,
            response: response.data
          }));
        }).catch(function (error) {
          if (error.response) {
            resolve((0, _getErrorMessage2.default)(errorMessageGenerator, {
              value: value,
              values: values,
              responseCode: error.response.status,
              response: error.response.data
            }));
            return;
          }
          resolve((0, _getErrorMessage2.default)(errorMessageGenerator, {
            value: value,
            values: values,
            responseCode: undefined,
            response: undefined,
            error: error
          }));
        });
      });
    };
  };
};